// Local storage keys
export const LS_DRAFT_KEY = "invoice-draft-v3";
export const LS_DUE_DAYS_KEY = "invoice-due-days";
export const LS_LANGUAGE_KEY = "invoice-language";
export const LS_CLIENTS_KEY = "invoice-clients";
export const LS_PAYMENT_METHODS_KEY = "invoice-payment-methods";
export const LS_ONBOARDING_COMPLETED = "invoice-onboarding-completed";
export const LS_INVOICE_LIST_ONBOARDING_COMPLETED = "invoice-list-onboarding-completed";

// Language support
export const languages = {
    en: { name: "English", code: "en" },
    cs: { name: "Čeština", code: "cs" },
    sk: { name: "Slovenčina", code: "sk" },
    ru: { name: "Русский", code: "ru" },
    uk: { name: "Українська", code: "uk" },
    de: { name: "Deutsch", code: "de" }
};

// Default values
export const DEFAULT_DUE_DAYS = 14;
export const DEFAULT_CURRENCY = 'CZK';
export const DEFAULT_LANGUAGE = 'en';

// Trial period
export const TRIAL_DAYS = 30;

// Supported currencies
export const SUPPORTED_CURRENCIES = ['CZK', 'EUR', 'USD', 'GBP'];

// Payment option types
export const PAYMENT_OPTION_TYPES = {
    BANK_TRANSFER: 'bank_transfer',
    CASH: 'cash',
    CARD: 'card',
    CRYPTO: 'crypto',
    OTHER: 'other'
} as const;

// VAT rates
export const DEFAULT_VAT_RATE = 21; // Czech VAT rate
export const SUPPORTED_VAT_RATES = [0, 5, 10, 15, 21];

// File upload limits
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

// Invoice template names and style options
export const INVOICE_TEMPLATES = {
    standard: 'Стандартный',
    minimal: 'Минималистичный',
    corporate: 'Корпоративный',
    creative: 'Креативный',
    elegant: 'Элегантный',
    modern: 'Современный',
    classic: 'Классический',
    colorful: 'Цветной',
    blackWhite: 'Черно-белый',
    premium: 'Премиум'
} as const;

export const INVOICE_STYLES = {
    ordinary: 'Обычный стиль',
    strict: 'Строгий стиль',
    elegant: 'Элегантный',
    modern: 'Современный',
    classic: 'Классический',
    minimal: 'Минималистичный'
} as const;

// Array of template names for dropdowns
export const INVOICE_TEMPLATE_NAMES = Object.values(INVOICE_TEMPLATES);

// Array of style names for dropdowns
export const INVOICE_STYLE_NAMES = Object.values(INVOICE_STYLES);
